import { useState, useMemo, useCallback, useEffect } from 'react';

export const useGallery = (images) => {
  const [index, setIndex] = useState(0);
  const [preloadImages, setPreloadImages] = useState(false);
  const selected = useMemo(() => ({ index, ...images[index] }), [images, index]);

  // Make sure images loop from the last back to the first
  const getImageIndex = useCallback((index) => index - Math.floor(index / images.length) * images.length, [images]);

  // Pre fetch some images once users begin to interact with the gallery
  useEffect(() => {
    if (!images?.length || !preloadImages) return;

    [-3, -2, -1, 1, 2, 3].forEach((n) => {
      const image = images[getImageIndex(index + n)];
      if (image) {
        const el = document.createElement('img');
        el.src = image.urlLarge;
      }
    });
  }, [index, images, getImageIndex, preloadImages]);

  const switchToImage = useCallback(
    (imageIndex) => {
      setIndex(getImageIndex(imageIndex));
      setPreloadImages(true);
    },
    [getImageIndex],
  );

  return {
    selected,
    switchToImage,
  };
};
